import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  html {
    scroll-behavior: auto !important;
  }

  body {
    background-color: ${props => props.theme.body};
    color: ${props => props.theme.text};
    transition: all 0.3s ease;
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    overscroll-behavior-y: none;
    overflow-anchor: none;
    -webkit-overflow-scrolling: touch;
  }

  a {
    color: ${props => props.theme.primary};
    text-decoration: none;
  }

  * {
    box-sizing: border-box;
  }
  
  /* Optimizaciones para transiciones de página */
  .message-composer-container {
    contain: layout style paint;
    transform: translateZ(0);
    will-change: transform;
    position: relative;
    z-index: 5;
  }

  /* Personalización del scrollbar para tema oscuro */
  body.dark-mode {
    scrollbar-width: thin;
    scrollbar-color: #3a3b3c #18191a;
  }

  body.dark-mode::-webkit-scrollbar {
    width: 8px;
  }

  body.dark-mode::-webkit-scrollbar-track {
    background: #18191a;
  }

  body.dark-mode::-webkit-scrollbar-thumb {
    background-color: #3a3b3c;
    border-radius: 20px;
  }

  /* Transiciones suaves para cambios de tema */
  .fade-transition {
    transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
  }
`;

export default GlobalStyles;
